import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import { States } from "../../shared/config/constant.module";
import template from './downtimeShiftReport.tpl.html';
import { StateParams } from "../../common";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import ReportServiceName, { ReportService } from "../../services/reports/report.service";
import DowntimeServiceName, { DowntimeService } from "../../services/downtimes/downtime.service";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import { Plant } from '../../models/navigation';
import { apsViewModels } from '../../shared/dto/APS.ViewModels';
import { DowntimeType } from "../../models/downtime";
import { flatten, sum } from 'lodash';
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";

let requires = [LoaderServiceName, DowntimeServiceName, ReportServiceName, AuthDataServiceName, NavigationServiceName];

interface DowntimeShiftReportController {
  plants: Plant[];
  selectedPlant: Plant;
  reportDate: Date;
  form: angular.IFormController;
  report: apsViewModels.DowntimeShopSections[];
  summary: apsViewModels.DowntimeShopItem[];
  summaryByArea: apsViewModels.DowntimeShopAreaItem[];
  formattedReportDate: string;
  showLines: boolean;
  shiftName: string;  // used to keep track of what shift we're on as the table is rendering
  downtimeType: DowntimeType;
  downtimeTypes: DowntimeType[];
  machineOnly(): void;
  updatePlant(): void;
  isSingleDayReport: boolean;
  showReportData: boolean;
  radioChange(any): void;
}

export interface DowntimeShiftReportParams extends StateParams {
  reportPlantId: string;
  reportDate: string;
  startDate: string;
  endDate: string;
}

class DowntimeShiftReportCtrl implements DowntimeShiftReportController {
  plants: Plant[];
  selectedPlant: Plant;
  startDate: Date;
  endDate: Date;
  reportStartDate: Date;
  reportEndDate: Date;
  reportDate: Date;
  form: angular.IFormController;
  report: apsViewModels.DowntimeShopSections[];
  summary: apsViewModels.DowntimeShopItem[];
  summaryByArea: apsViewModels.DowntimeShopAreaItem[];
  formattedReportDate: string;
  maxMachineSections: number;
  showLines: boolean;
  shiftName: string;
  downtimeType: DowntimeType;
  downtimeTypes: DowntimeType[];
  isSingleDayReport: boolean;
  showReportData: boolean;
  $state: angular.ui.IStateService;
  loaderService: LoaderService;
  reportService: ReportService;
  downtimeService: DowntimeService;
  authDataService: AuthDataService;
  notifyService: NotifyService;
  $q: angular.IQService;

  reportLoadingPromise: angular.IDeferred<any>;
  reportAvailableThisWorkaround: any;

  private $stateParams: DowntimeShiftReportParams;

  constructor(
    $state: angular.ui.IStateService,
    $stateParams: DowntimeShiftReportParams,
    navigationService: NavigationService,
    reportService: ReportService,
    downtimeService: DowntimeService,
    loaderService: LoaderService,
    authDataService: AuthDataService,
    notifyService: NotifyService,
    $q: angular.IQService) {

    var vm = this;

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.loaderService = loaderService;
    this.reportService = reportService;
    this.downtimeService = downtimeService;
    this.authDataService = authDataService;
    this.notifyService = notifyService;
    this.$q = $q;

    this.reportDate = moment().add(-1, 'days').toDate();
    var now = moment().add(1, 'hours').startOf('hour');
    this.reportEndDate = now.toDate();
    this.reportStartDate = now.clone().subtract(1, 'days').toDate();
    this.isSingleDayReport = true;
    var promise = navigationService.getNavigation().then((navModel) => {
      this.plants = navModel.plants();
      this.selectedPlant = navModel.selectedPlant;

      return this.loadState($stateParams).then(function (data) {
        vm.downtimeTypes = data.downtimeTypes;
        let streamId = '00000000-0000-0000-0000-000000000000';
        let toolChangeId = 'bbdf0000-3a00-000d-c122-08d2e5fba957';
        vm.downtimeTypes.push(new DowntimeType(streamId, 'Streaming'));
        vm.downtimeTypes.push(new DowntimeType(toolChangeId, 'Tool Change'));
      });

    });

    loaderService.loadingPromise(promise);
  }

  loadState(params: DowntimeShiftReportParams): angular.IPromise<any> {
    if (params.reportPlantId && params.reportPlantId !== params.plantId) {
      var plant = _.find(this.plants, { id: params.reportPlantId });
      if (plant) {
        this.selectedPlant = plant;
      }
    }

    if (params.reportDate) {
      var reportDate = moment(params.reportDate);
      if (reportDate.isValid()) {
        this.reportDate = reportDate.toDate();
      }
    }
    if (params.startDate) {
      var startDate = moment(params.startDate);
      if (startDate.isValid()) {
        this.startDate = startDate.toDate();
      }
    }
    return this.getDowntimeTypes();

  }
  machineOnly(): void {
    this.report = null;
    if (this.showLines) {
      this.showLines = false;
    } else {
      this.showLines = true;
    }
  }

  updatePlant(): void {
    this.report = null;
  }

  radioChange(type): void {
    if (type === 'single') {
      this.isSingleDayReport = true;
    }
    else {
      this.isSingleDayReport = false;
    }
  }
  saveState(): void {
    var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
    if (reportPlantId === this.$stateParams.plantId) {
      reportPlantId = undefined;
    }
    var params: DowntimeShiftReportParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: reportPlantId,
      reportDate: this.reportDate ? this.reportDate.toISOString() : undefined,
      startDate: this.startDate ? this.startDate.toISOString() : undefined,
      endDate: this.endDate ? this.endDate.toISOString() : undefined
    };

    this.$state.transitionTo(this.$state.current.name, params);
  }

  generateReport(regenerate: boolean) {
    if (this.form.$invalid) {
      return;
    }
    if (!this.isSingleDayReport) {
      var diff = moment(this.endDate).diff(this.startDate, 'days')

      if (diff > 185) {
        this.notifyService.error('Date range cannot exceed 6 months');
        return;
      }
      if (this.endDate < this.startDate) {
        this.notifyService.error('Report End Date should be greater than Report Start Date');
        return;
      }
    }
    this.saveState();
    this.loaderService.loadingPromise(this.runReport());
    this.formattedReportDate = moment(this.reportDate).format("dddd, MM/DD/YYYY");
  }

  private runReport(): angular.IPromise<any> {

    let downtimeTypeId = null;

    if (this.downtimeType) {
      downtimeTypeId = this.downtimeType.downtimeTypeId;
    }
    let req = {
      isSingleDayReport: this.isSingleDayReport,
      plantId: this.selectedPlant.id,
      reportDate: this.reportDate,
      startDate: this.startDate,
      endDate: this.endDate,
      areaId: downtimeTypeId
    };
    let promise = this.reportService.getDowntimeShiftReport(req);

    promise.then((result: apsViewModels.DowntimeShopSectionsV1) => {
      let report = result.items;
      this.summary = result.summaries;
      this.summaryByArea = result.summariesByArea;
      if (this.showLines) {
        _.forEach(report, (i) => {
          i.downtimeDetailsReportItems = _.filter(i.downtimeDetailsReportItems, di => di.entireMachine === true);
          i.downtimeSummaryReportItems = _.filter(i.downtimeSummaryReportItems, di => di.section === null);
        });
        report = _.filter(report, x => x.downtimeDetailsReportItems.length > 0)
      }
      if (!this.isSingleDayReport) {
        this.showReportData = false;
        var start = moment(this.startDate).format("dddd, MM/DD/YYYY");
        var end = moment(this.endDate).format("dddd, MM/DD/YYYY");
        this.tableToCsv2(result.items, start + '-' + end + '_downtime_summary.csv')
      }
      else {
        this.showReportData = true;
      }
      this.report = report;
    });

    return promise;
  }

  getSectionName(summaryItem: apsViewModels.DowntimeSummaryReportItem): string {
    return summaryItem.nameSection.replace(" ", "");
  }

  getShiftRows(detailsItem: apsViewModels.DowntimeDetailsReportItemDowntime[], shiftName: string): number {
    this.shiftName = shiftName;
    return detailsItem.filter(x => x.shiftName == shiftName).length;
  }

  getColumnMark(sectionName: string[], columnName: string): string {
    return (sectionName.filter(x => x == columnName).length > 0) ? "X" : "";
  }

  getSummaryShiftRows(item: apsViewModels.DowntimeShopItem): number {
    let a = Array.from(flatten(item.shift));
    let cnt = 0;
    _.forEach(a, (i) => {
      cnt += Array.from(flatten(i.reasons)).length;
    });

    return cnt;
  }


  getSummaryAreaRows(item: apsViewModels.DowntimeShopAreaItem): number {
    return Array.from(flatten(item.areas)).length;
  }

  getSummaryReasonRows(item: apsViewModels.DowntimeShopShift): number {
    return Array.from(flatten(item.reasons)).length;
  }

  getShopDowntime(item: apsViewModels.DowntimeShopItem, isentireMachine: boolean): number {
    let a = Array.from(flatten(item.shift));
    let sum = 0;
    _.forEach(a, (i) => {
      let b = Array.from(flatten(i.reasons));
      _.forEach(b, (k) => {
        if (k.entireMachine && isentireMachine) { sum += k.totalMinute; }
        else if (!k.entireMachine && !isentireMachine) { sum += k.totalMinute; }
      });
    });

    return sum;
  }

  getShopDowntime2(item: apsViewModels.DowntimeShopItem): number {
    let a = Array.from(flatten(item.shift));
    let sum = 0;
    _.forEach(a, (i) => {
      let b = Array.from(flatten(i.reasons));
      _.forEach(b, (k) => {
        sum += k.totalMinute;
      });
    });

    return sum;
  }
  getPlantDowntime(items: apsViewModels.DowntimeShopItem[]): number {
    let a = Array.from(flatten(items));
    let sum = 0;
    _.forEach(a, (i) => {
      sum += this.getShopDowntime2(i);
    });

    return sum;
  }

  getShopAreaDowntime(item: apsViewModels.DowntimeShopAreaItem, isentireMachine: boolean): number {
    let a = Array.from(flatten(item.areas));
    let sum = 0;
    _.forEach(a, (i) => {
      if (i.entireMachine && isentireMachine) { sum += i.totalMinute; }
      else if (!i.entireMachine && !isentireMachine) { sum += i.totalMinute; }
    });
    return sum;
  }
  getShopAreaDowntime2(item: apsViewModels.DowntimeShopAreaItem): number {
    let a = Array.from(flatten(item.areas));
    let sum = 0;
    _.forEach(a, (i) => {
      sum += i.totalMinute;
    });
    return sum;
  }

  getPlantAreaDowntime(items: apsViewModels.DowntimeShopAreaItem[]): number {
    let a = Array.from(flatten(items));
    let sum = 0;
    _.forEach(a, (i) => {
      sum += this.getShopAreaDowntime2(i);
    });

    return sum;
  }

  getDowntimeTypes(): angular.IPromise<any> {
    return this.downtimeService.getDowntimeTypesAndReasons();
  }

  // this function currently supports only 2 levels of merged columns
  tableToCsv(tableId: string, exportAsFileName: string, exclusionList: string[], mergedColCount: number, columnCount: number) {

    let headers = this.summary.map(x => { return x.shopName });
    let rows = (document.getElementById(tableId) as HTMLTableElement).rows;
    let result = "";

    let cols = Array.apply(null, Array(mergedColCount)).map(function (x, i) { return ''; })
    for (var row = 0; row < rows.length; row++) {
      let data = "";

      if (row > 0 && mergedColCount && mergedColCount > 0) {
        let c = rows[row].cells[0].innerText.trim();
        // capture 1st column header
        if (rows[row].cells.length == 1) {
          if (headers.indexOf(c) > -1) {
            cols[0] = c;
          }
          else {
            cols[1] = c;
          }
        }
        else {
          if (exclusionList && exclusionList.indexOf(c) > -1) {
            continue; // excluding row
          }
          else {
            _.forEach(cols, (col) => {
              data += '"' + col + '",';
            })
          }
        }
      }

      for (var column = 0; column < rows[row].cells.length; column++) {
        if (row == 0) {
          data += '"' + rows[row].cells[column].innerText.trim() + '",';
        }
        else {
          if (rows[row].cells.length > 1) {
            data += '"' + rows[row].cells[column].innerText.trim() + '",';
          }
        }
      }

      if (data.split(',').length >= (columnCount - 1)) {
        data += "\n";
      }

      result += data;
    }

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(new Blob([result], { type: 'text/csv;charset=utf-8;' }), exportAsFileName);
    } else {
      var a = document.createElement("a");
      a.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(result);
      a.target = '_blank';
      a.download = exportAsFileName;
      document.body.appendChild(a);
      a.click();
    }
  }
  tableToCsv2(items: apsViewModels.DowntimeShopSections[], exportAsFileName: string) {

    let result = "Shop, Shift, Date, Time, Reason, Area, Machine, Section, Cavity, MachineMinutes, SectionMinutes, Comments";
    result += "\n";
    for (var i = 0; i < items.length; i++) {
      var currentshop = items[i];
      for (var j = 0; j < currentshop.downtimeDetailsReportItems.length; j++) {
        var currentshift = currentshop.downtimeDetailsReportItems[j];
        result += '"' + currentshop.shopName + '",';
        result += '"' + currentshift.shiftName + '",';
        result += '"' + moment(currentshift.startTime).format("YYYY-MM-DD") + '",';
        result += '"' + moment(currentshift.startTime).format("HH:mm:ss") + '",';
        //result += '"' + currentshift.duration + '",';
        result += '"' + currentshift.reason + '",';
        result += '"' + currentshift.downtimeArea + '",';
        result += '"' + currentshift.machineName + '",';
        result +=  currentshift.section == null  ? '"' + 'N/A' + '",' :  '"'  + currentshift.section +'",';
        result +=  currentshift.gobName == null  ? '"' + 'N/A' + '",' :  '"'  + currentshift.gobName +'",';
        result +=  currentshift.entireMachine == true  ? '"' + currentshift.duration + '",' :  '"'  + ' ' +'",';
        result +=  currentshift.entireMachine == false  ? '"' + currentshift.duration + '",' :  '"'  + ' ' +'",';
        result +=  currentshift.comment == null  ? '"' + '' + '",' :  '"'  + currentshift.comment +'",';
        result += "\n";
      }
    }
    var a = document.createElement("a");
    a.href = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(result);
    a.target = '_blank';
    a.download = exportAsFileName;
    document.body.appendChild(a);
    a.click();
  }  
}

export default angular.module('aps.controller.downtimeShiftReport', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.DOWNTIME_SHIFT_REPORT,
      url: '/DowntimeShiftReport',
      params: {
        reportDate: { dynamic: true },
        reportPlantId: { dynamic: true }
      },
      controller: 'DowntimeShiftReportCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Downtime Shift Report'
      }
    });
  })
  .controller('DowntimeShiftReportCtrl', DowntimeShiftReportCtrl)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/reports/downtimeShiftReport.controller.ts